// extracted by mini-css-extract-plugin
export default {"typing-message":"typing-message__14Kyo","typing-message__dots":"typing-message__dots__3XF4C","fade-in":"fade-in__2F_0o","fade-out":"fade-out__3wNyo"};